angular.module('miq.card', ['miq.util']);
